import { apiFetch } from '../lib/api';
import type {
  SessionListResponse,
  SessionResponse,
  SessionParticipantDto,
  CreateSessionRequest,
  UpdateSessionRequest,
  AddParticipantRequest,
  CatchesListResponse,
} from '../types/api';

export function listSessions(params: {
  page?: number;
  pageSize?: number;
  status?: 'active' | 'ended';
}): Promise<SessionListResponse> {
  const qs = new URLSearchParams();
  if (params.page != null) qs.set('page', String(params.page));
  if (params.pageSize != null) qs.set('pageSize', String(params.pageSize));
  if (params.status) qs.set('status', params.status);
  const query = qs.toString();
  return apiFetch<SessionListResponse>(`/api/sessions${query ? `?${query}` : ''}`);
}

export function getSession(id: number): Promise<SessionResponse> {
  return apiFetch<SessionResponse>(`/api/sessions/${id}`);
}

export function createSession(req: CreateSessionRequest): Promise<SessionResponse> {
  return apiFetch<SessionResponse>('/api/sessions', { method: 'POST', body: req });
}

export function updateSession(id: number, req: UpdateSessionRequest): Promise<SessionResponse> {
  return apiFetch<SessionResponse>(`/api/sessions/${id}`, { method: 'PATCH', body: req });
}

export function endSession(id: number): Promise<SessionResponse> {
  return apiFetch<SessionResponse>(`/api/sessions/${id}/end`, { method: 'POST' });
}

export function deleteSession(id: number): Promise<void> {
  return apiFetch<void>(`/api/sessions/${id}`, { method: 'DELETE' });
}

export function addParticipant(id: number, req: AddParticipantRequest): Promise<SessionParticipantDto> {
  return apiFetch<SessionParticipantDto>(`/api/sessions/${id}/participants`, { method: 'POST', body: req });
}

export function listSessionCatches(
  id: number,
  params?: { page?: number; pageSize?: number },
): Promise<CatchesListResponse> {
  const qs = new URLSearchParams();
  if (params?.page != null) qs.set('page', String(params.page));
  if (params?.pageSize != null) qs.set('pageSize', String(params.pageSize));
  const query = qs.toString();
  return apiFetch<CatchesListResponse>(`/api/sessions/${id}/catches${query ? `?${query}` : ''}`);
}
